import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Usuarios } from '@app/entidades/usuario.model';
import { environment } from '@env';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsuariosService {
  private baseUrl = environment.apiResrURL;
  private usuariosUrl = `${this.baseUrl}/sgi-usuarios`;

  constructor(private http: HttpClient) {}

  public validarCorreo(mail: any): Observable<any> {
    return this.http.get(`${this.usuariosUrl}/verificarMail?mail=${mail}`);
  }

  public nuevoUsuario(user: Usuarios): Observable<any> {
    return this.http.post<Usuarios>(`${this.usuariosUrl}/nuevo`, user);
  }

  public usuario(id: any): Observable<any> {
    return this.http.get<Usuarios>(`${this.usuariosUrl}/?id=${id}`);
  }

  // public validarClave( pass: any,id: any) : Observable<any>{
  //   return this.http.get<any>(`${environment.apiResrURL}/api/usuarios/verificarPass?pass=${pass}&id=${id}`);
  // }

  public modificarClave(
    id: string | number,
    pass1: string,
    pass2: string
  ): Observable<any> {
    return this.http.get<Usuarios>(
      `${this.usuariosUrl}/password?id=${id}&pass1=${pass1}&pass2=${pass2}`
    );
  }
}
